// extracted by mini-css-extract-plugin
module.exports = {"previewContainer":"OrderPreview_previewContainer__1vnZ-"};